import { ApiContainerByIdQuery } from '../contentModels/ApiContainer';
import { BodyCopyByIdQuery } from '../contentModels/BodyCopy';
import { ColumnBlockByIdQuery } from '../contentModels/ColumnBlock';
import { ContentBlockByIdQuery } from '../contentModels/ContentBlock';
import { ContentBlockGroupByIdQuery } from '../contentModels/ContentBlockGroup';
import { HeyDoctorServicesGalleryByIdQuery } from '../contentModels/HeyDoctorServicesGallery';
import { ImageBlockByIdQuery } from '../contentModels/ImageBlock';
import { ImageFeatureByIdQuery } from '../contentModels/ImageFeature';
import { LayoutBlockByIdQuery } from '../contentModels/LayoutBlock';
import { LinkByIdQuery } from '../contentModels/Link';
import { LinkGroupByIdQuery } from '../contentModels/LinkGroup';
import { PageContainerByIdQuery, PageContainerBySlugQuery } from '../contentModels/PageContainer';
import { PageMetaByIdQuery } from '../contentModels/PageMeta';
import { PlaceholderByIdQuery } from '../contentModels/Placeholder';
import { SectionByIdQuery } from '../contentModels/Section';
import { TextBlockByIdQuery } from '../contentModels/TextBlock';
import { WrapperBlockByIdQuery } from '../contentModels/WrapperBlock';
export const queryMap = {
  ApiContainer: () => ApiContainerByIdQuery,
  BodyCopy: () => BodyCopyByIdQuery,
  ColumnBlock: () => ColumnBlockByIdQuery,
  ContentBlock: () => ContentBlockByIdQuery,
  ContentBlockGroup: () => ContentBlockGroupByIdQuery,
  HeyDoctorServicesGallery: () => HeyDoctorServicesGalleryByIdQuery,
  ImageBlock: () => ImageBlockByIdQuery,
  ImageFeature: () => ImageFeatureByIdQuery,
  LayoutBlock: () => LayoutBlockByIdQuery,
  Link: () => LinkByIdQuery,
  LinkGroup: () => LinkGroupByIdQuery,
  PageContainer: () => PageContainerByIdQuery,
  PageContainerBySlug: () => PageContainerBySlugQuery,
  PlaceholderByIdQuery: () => PlaceholderByIdQuery,
  PageMeta: () => PageMetaByIdQuery,
  Section: () => SectionByIdQuery,
  TextBlock: () => TextBlockByIdQuery,
  WrapperBlock: () => WrapperBlockByIdQuery
};